import instance from './axiosInstance';

export function getBenchmarkData(reqBody, options = {}, http = instance) {
  return http.post('/benchmark', reqBody, options);
}

export function getSupportedMetrics(http = instance) {
  return http.get('/supportedmetrics');
}
